;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.9";import * as Sentry from "@sentry/nextjs";

// Sentry Logs has no session sampling, so decide once per page load to keep volume at
// the 15% of sessions Grafana Faro used to collect.
const LOGS_SAMPLE_RATE = 0.15;
const isLogSampled = Math.random() < LOGS_SAMPLE_RATE;

// Browser-only Sentry initialization.
// Browser-only APIs (e.g. replayIntegration) must live here, NOT in instrumentation.ts,
// because instrumentation.ts also runs in the edge runtime where they are unavailable.
Sentry.init({
  // DSN is configured per environment via NEXT_PUBLIC_SENTRY_DSN in deployment settings.
  // The NEXT_PUBLIC_ prefix is required for client-side access.
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,

  // Uncomment to enable SDK debug logging in development (outputs DSN, init status, each sent event).
  // debug: process.env.NODE_ENV === "development",

  // v10: sendDefaultPii controls whether user IP addresses are collected.
  // Set to true explicitly to opt in if IP tracking is required.
  sendDefaultPii: false,

  // Sends console output to Sentry Logs, replacing what Grafana Faro used to collect.
  enableLogs: true,
  beforeSendLog: log => (isLogSampled ? log : null),

  integrations: [
    Sentry.consoleLoggingIntegration({ levels: ["info", "warn", "error"] }),
    Sentry.replayIntegration({
      networkDetailAllowUrls: [
        "https://binder.papercup.com",
        "https://binder-dev.papercup.com",
        "https://binder.papercup.com",
        "https://binder-gamma.papercup.com",
        "https://binder-delta.papercup.com",
        "https://binder-beta.papercup.com",
        "https://binder-petri.papercup.com"
      ],
      networkCaptureBodies: true
    })
  ],
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // this enables performance monitoring
  tracesSampleRate: 0.15,

  ignoreErrors: [
    // These events occur very frequently, and there is not much we can do about it
    "Non-Error promise rejection captured with keys: currentTarget, isTrusted, target, type",
    "ResizeObserver loop limit exceeded",
    "AbortError: The play() request was interrupted by a call to pause().",
    "NotSupportedError: The element has no supported sources."
  ]
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
